export const SET_ORDER = 'shipstation/SET_ORDER';
